module.exports = __webpack_public_path__ + "static/deliver-engaging-content-bb862e713a096e3f3de63b35f910468c.svg";